import { Select as _Select } from './Select';
import { SelectChild } from './Select.Child';
import { SelectFooter } from './Select.Footer';
import { SelectOption } from './Select.Option';
export var Select = Object.assign(_Select, {
  Child: SelectChild,
  Footer: SelectFooter,
  Option: SelectOption
});